import { SignupType } from "@nuskin/ns-signup-api-client";

const TAX_IDS = {
  BUSINESS: "business",
  PERSONAL: "personal",
};

const BA_PERSONAL_TAX_ID = new Map([
  [SignupType.BRAND_AFFILIATE, TAX_IDS.PERSONAL],
]);
const BA_BUSINESS_TAX_ID = new Map([
  [SignupType.BRAND_AFFILIATE, TAX_IDS.BUSINESS],
]);

/**
 * List of market infos
 * @constant {MarketInfo[]}
 */
export const asList = [
  // ===========================================================================
  // North America Region
  // ===========================================================================

  // Canada

  {
    code: "CA",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["en", "fr", "zh"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Mexico

  {
    code: "MX",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["es"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // United States

  {
    code: "US",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["en", "vi", "es", "zh"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // ===========================================================================
  // Central & South America Region
  // ===========================================================================

  // Argentina

  {
    code: "AR",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["es"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Chile

  {
    code: "CL",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["es"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Colombia

  {
    code: "CO",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["es"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Peru

  {
    code: "PE",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["es"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // ===========================================================================
  // Europe Region
  // ===========================================================================

  // Austria
  //
  {
    code: "AT",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["de", "en"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Belgium

  {
    code: "BE",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["nl", "fr", "en", "de"],
    taxId: new Map(),
  },

  // Switzerland

  {
    code: "CH",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["it", "de", "fr", "en"],
    taxId: new Map(),
  },

  // Czech Republic

  {
    code: "CZ",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["cs", "en"],
    taxId: new Map(),
  },

  // Germany

  {
    code: "DE",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["de", "en"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Denmark
  //
  {
    code: "DK",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["da", "en"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Spain

  {
    code: "ES",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["es", "en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Finland
  //
  {
    code: "FI",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["sv", "en", "fi"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // France

  {
    code: "FR",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["fr", "zh", "en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // United Kingdom

  {
    code: "GB",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Hungary
  //
  {
    code: "HU",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["hu", "en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Ireland
  //
  {
    code: "IE",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Iceland
  //
  {
    code: "IS",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["en"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Italy
  //
  {
    code: "IT",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["it", "zh", "en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Luxembourg

  {
    code: "LU",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["fr", "en", "de"],
    taxId: new Map(),
  },

  // Netherlands

  {
    code: "NL",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["nl", "en"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Norway

  {
    code: "NO",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["no", "en", "th"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Poland

  {
    code: "PL",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["en", "pl"],
    taxId: new Map(),
  },

  // Portugal

  {
    code: "PT",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["pt", "en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Romania

  {
    code: "RO",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["ro", "en"],
    taxId: new Map(),
  },

  // Russia

  {
    code: "RU",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["ru", "en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Sweden

  {
    code: "SE",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["sv", "en", "th"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Slovakia

  {
    code: "SK",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["sk", "en"],
    taxId: new Map(),
  },

  // Turkey

  {
    code: "TR",
    signupTypes: [],
    languages: ["en", "tr"],
    taxId: new Map(),
  },

  // Ukraine

  {
    code: "UA",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["ru", "en", "uk"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // ===========================================================================
  // Greater China Region
  // ===========================================================================

  // China
  //
  // {
  //     code: "CN",
  //     signupTypes: [

  //     ],
  //     languages: ["zh"],
  //     taxId: new Map(),
  // },

  // Hong Kong
  {
    code: "HK",
    signupTypes: [SignupType.MEMBER, SignupType.BRAND_AFFILIATE],
    languages: ["zh", "en"],
    taxId: new Map(),
    memberFloatPool: true,
  },

  // Macau
  {
    code: "MO",
    signupTypes: [SignupType.MEMBER, SignupType.BRAND_AFFILIATE],
    languages: ["zh", "en"],
    taxId: new Map(),
  },

  // Taiwan
  //
  // {
  //     code: "TW",
  //     signupTypes: [

  //     ],
  //     languages: ["zh"],
  //     taxId: new Map(),
  // },

  // ===========================================================================
  // Asia Pacific Region
  // ===========================================================================

  // Australia

  {
    code: "AU",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["en"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Brunei

  {
    code: "BN",
    signupTypes: [SignupType.BRAND_AFFILIATE],
    languages: ["en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Indonesia

  {
    code: "ID",
    signupTypes: [SignupType.BRAND_AFFILIATE],
    languages: ["en", "in"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Japan

  {
    code: "JP",
    signupTypes: [SignupType.MEMBER],
    languages: ["ja"],
    taxId: new Map(),
  },

  // South Korea

  {
    code: "KR",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["ko"],
    taxId: new Map(),
  },

  // Malaysia

  {
    code: "MY",
    signupTypes: [SignupType.BRAND_AFFILIATE],
    languages: ["en", "zh", "ms"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // New Caledonia

  {
    code: "NC",
    signupTypes: [
      SignupType.BRAND_AFFILIATE,
      SignupType.MEMBER,
      SignupType.CUSTOMER,
    ],
    languages: ["fr"],
    taxId: new Map(),
  },

  // New Zealand

  {
    code: "NZ",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["en"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // French Polynesia

  {
    code: "PF",
    signupTypes: [
      SignupType.BRAND_AFFILIATE,
      SignupType.MEMBER,
      SignupType.CUSTOMER,
    ],
    languages: ["fr"],
    taxId: BA_BUSINESS_TAX_ID,
  },

  // Philippines

  {
    code: "PH",
    signupTypes: [SignupType.MEMBER, SignupType.BRAND_AFFILIATE],
    languages: ["en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Singapore

  {
    code: "SG",
    signupTypes: [SignupType.MEMBER, SignupType.BRAND_AFFILIATE],
    languages: ["en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Thailand

  {
    code: "TH",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["th", "en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // Vietnam

  {
    code: "VN",
    signupTypes: [SignupType.MEMBER, SignupType.BRAND_AFFILIATE],
    languages: ["en", "vi"],
    taxId: new Map([
      [SignupType.MEMBER, TAX_IDS.PERSONAL],
      [SignupType.BRAND_AFFILIATE, TAX_IDS.PERSONAL],
    ]),
  },

  // ===========================================================================
  // Middle East/Africa Region
  // ===========================================================================

  // Israel

  {
    code: "IL",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["iw", "en"],
    taxId: BA_PERSONAL_TAX_ID,
  },

  // South Africa

  {
    code: "ZA",
    signupTypes: [
      SignupType.CUSTOMER,
      SignupType.MEMBER,
      SignupType.BRAND_AFFILIATE,
    ],
    languages: ["en", "zh"],
    taxId: BA_PERSONAL_TAX_ID,
  },
];

/**
 * @typedef MarketInfo
 * @prop {string} code market code
 * @prop {SignupType[]} signupTypes available signup types
 * @prop {string[]} languages available language codes
 * @prop {Map<SignupType, TaxIdType>} taxId what type of tax ID to use for a signup type
 */

/**
 * @typedef {'business'|'personal'} TaxIdType
 */

/**
 * @typedef {'BRAND_AFFILIATE'|'MEMBER'|'CUSTOMER'} SignupType
 */

/**
 * Map of market codes to market information
 * @constant {Map<string, MarketInfo>}
 */
export const asMarketMap = new Map(asList.map((it) => [it.code, it]));

/**
 * Map of locales to signup types
 * @constant {Map<string, SignupType[]>}
 */
export const asLocaleMap = new Map(
  flatMap(asList, ({ code, languages, signupTypes }) => {
    return languages.map((lang) => [`${lang}_${code}`, signupTypes]);
  })
);

/**
 * Flat Map polyfill
 * @param {[]} array array to flat map
 * @param {Function} fn mapping function
 */
function flatMap(array, fn) {
  return array.reduce((arr, each) => arr.concat(fn(each)), []);
}
